"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _multiRequestEpic = _interopRequireDefault(require("settings-ui-sdk/multiRequestEpic"));

var _epics = require("settings-ui-sdk/PortalSettings/epics");

var _epics2 = require("settings-ui-sdk/I18n/epics");

var _epics3 = require("settings-ui-sdk/Hubs/epics");

var _epics4 = require("settings-ui-sdk/UnifiedBranding/epics");

var _actions = require("settings-ui-sdk/PortalSettings/actions");

var _actions2 = require("settings-ui-sdk/I18n/actions");

var _actions3 = require("settings-ui-sdk/Hubs/actions");

var _actions4 = require("settings-ui-sdk/UnifiedBranding/actions");

var _selectors = require("settings-ui-sdk/PortalSettings/selectors");

var _selectors2 = require("settings-ui-sdk/I18n/selectors");

var _selectors3 = require("settings-ui-sdk/Hubs/selectors");

var _selectors4 = require("settings-ui-sdk/UnifiedBranding/selectors");

var _AccountDefaultsActions = require("../actions/AccountDefaultsActions");

var _selectors5 = require("../selectors");

var _default = (0, _multiRequestEpic.default)({
  requestEpics: [_epics.savePortalSetting, _epics2.saveI18nSetting, _epics3.saveHub, _epics4.saveBrandingEpic],
  mapStateToInitiatingActions: function mapStateToInitiatingActions(state) {
    var initiatingActions = (0, _selectors.getStagedChanges)(state).reduce(function (acc, val, key) {
      return [].concat((0, _toConsumableArray2.default)(acc), [(0, _actions.savePortalSetting)(key, val)]);
    }, []);

    if (!(0, _selectors3.getStagedChanges)(state).isEmpty()) {
      initiatingActions.push((0, _actions3.saveHub)((0, _selectors3.getStagedChanges)(state).toJS()));
    }

    if (!(0, _selectors2.getStagedChanges)(state).isEmpty()) {
      initiatingActions.push((0, _actions2.saveI18nSetting)((0, _selectors2.getSelectedLanguage)(state), (0, _selectors2.getLocale)(state)));
    }

    if ((0, _selectors4.getStagedChangesCount)(state) > 0) {
      initiatingActions.push((0, _actions4.saveBranding)((0, _selectors4.getStagedChanges)(state).toJS()));
    }

    return initiatingActions;
  },
  metaInitiatingActionType: _AccountDefaultsActions.AccountDefaultActionTypes.SAVE_STAGED_CHANGES,
  metaRequestActions: _AccountDefaultsActions.SaveStagedChanges,
  metaRequestStatusSelector: _selectors5.getSaveRequestStatus
});

exports.default = _default;
module.exports = exports.default;